import { render, staticRenderFns } from "./CheckOrX.vue?vue&type=template&id=0796b219"
import script from "./CheckOrX.vue?vue&type=script&lang=js"
export * from "./CheckOrX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports